import React from 'react';
import PropTypes from 'prop-types';

const SearchPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M13 19a6 6 0 1 1 0-12 6 6 0 0 1 0 12m15.575 7.453l-8.239-8.238A8.956 8.956 0 0 0 22 13a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9 8.956 8.956 0 0 0 5.215-1.664l8.238 8.239a1.502 1.502 0 0 0 2.122 0 1.502 1.502 0 0 0 0-2.122"
    />
  );
};

SearchPath.propTypes = {
  fill: PropTypes.string,
};

export default SearchPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/search.jsx